var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('main',{staticClass:"ml-sm-auto col-xl-10 px-4",attrs:{"role":"main"}},[_c('div',{staticClass:"d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"},[_c('h1',{staticClass:"h2"},[_vm._v("Page non trouvé !")])])])])
}]

export { render, staticRenderFns }